import Membership from "@/domain/order/Membership";

interface IComplexPayment {
  paymentMethod: string;
  paymentAmount: number;
  points?: Array<Membership>;
}

class ComplexPayment {

  constructor(args: IComplexPayment) {
    return Object.assign(this, args);
  }
}

interface ComplexPayment extends IComplexPayment {
}

export default ComplexPayment;